var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFieldclixLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 387.11 79.55",
    style: {
      enableBackground: "new 0 0 387.11 79.55"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0CB06F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "36.6,71.71 9,38.81 16.66,32.38 37.84,57.62 79.55,22.62 79.55,16.01 41.3,48.11 27.27,31.38 34.93,24.96 42.53,34.02 79.55,2.96 79.55,0 0,0 0,79.55 79.55,79.55 79.55,35.67  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.91,66.72V13.09h36.75v8.28h-27.34V35.2h26.78v8.28h-26.78v23.24H96.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.98,17.91c0-2.89,2.33-5.23,5.23-5.23c2.89,0,5.23,2.33,5.23,5.23c0,2.89-2.33,5.23-5.23,5.23 C143.31,23.14,140.98,20.81,140.98,17.91z M141.94,66.72V27.88h8.44v38.84H141.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158.99,47.26c0-11.26,8.2-20.34,19.7-20.34c11.66,0,19.06,8.84,19.06,21.07v2.09h-29.91 c0.64,5.79,4.99,10.69,12.3,10.69c3.86,0,8.28-1.53,11.1-4.34l3.86,5.55c-3.94,3.7-9.65,5.71-15.76,5.71 C167.6,67.69,158.99,59.56,158.99,47.26z M178.61,33.83c-7.16,0-10.53,5.55-10.86,10.21h21.87 C189.39,39.46,186.25,33.83,178.61,33.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M206.11,66.72V13.09h8.44v53.63H206.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M252.83,66.72v-5.31c-2.98,3.86-7.4,6.27-12.46,6.27c-9.89,0-17.21-7.56-17.21-20.42 c0-12.54,7.24-20.34,17.21-20.34c4.9,0,9.41,2.17,12.46,6.35V13.09h8.44v53.63H252.83z M252.83,54.98V39.62 c-1.85-2.89-6.03-5.23-9.97-5.23c-6.75,0-11.02,5.39-11.02,12.87c0,7.56,4.26,12.95,11.02,12.95 C246.8,60.21,250.98,57.88,252.83,54.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M269.88,47.26c0-11.74,8.28-20.34,20.02-20.34c7.64,0,12.14,3.22,14.88,6.91l-5.55,5.07 c-2.17-3.06-5.15-4.5-8.93-4.5c-7,0-11.74,5.31-11.74,12.87c0,7.56,4.74,12.95,11.74,12.95c3.78,0,6.75-1.61,8.93-4.66l5.55,5.23 c-2.73,3.62-7.24,6.92-14.88,6.92C278.16,67.69,269.88,59,269.88,47.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M312.26,66.72V13.09h8.44v53.63H312.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M330.67,17.91c0-2.89,2.33-5.23,5.23-5.23c2.89,0,5.23,2.33,5.23,5.23c0,2.89-2.33,5.23-5.23,5.23 C333,23.14,330.67,20.81,330.67,17.91z M331.63,66.72V27.88h8.44v38.84H331.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M375.62,66.72l-10.05-14.31l-10.13,14.31h-9.49l14.31-19.94l-13.43-18.9h9.49l9.17,13.11l9.25-13.11h9.49 l-13.43,18.9l14.31,19.94H375.62z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldclixLogo);
export default __webpack_public_path__ + "static/media/Fieldclix-Logo.831d88856302fd99e90fed5d9e4c82d5.svg";
export { ForwardRef as ReactComponent };